import React from 'react'
import ReactDOM from 'react-dom'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

import App from './App'
// Font Awesome setup
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog } from '@fortawesome/free-solid-svg-icons';
// Add icons to library
library.add(faCog);

ReactDOM.render(
  <App />,
  document.getElementById('root')
)
